import React, { Component } from 'react'
import style from './style.css'

import T from '../../translate/T'

import InputIcon from '../../molecules/InputIcon'
import { Checkbox } from '../../atoms/Forms'
import { Col, Row } from '../../atoms/Grid'

class SearchFilter extends Component {

    state = {
        filter: '',
        events: true,
        athletes: true,
        experiences: true
    }

    render() {
        return (
            <form onSubmit={(e) => {
                e.preventDefault()
                this.props.onSubmit(this.state)
            }}>
                <Row>
                    <Col size={12}>
                        <InputIcon
                            placeholder={this.props.placeholder}
                            icon="search"
                            iconAction={() => {
                                this.props.onSubmit(this.state)
                            }}
                            handleChange={(e) => {
                                this.setState({
                                    filter: e.target.value
                                })
                            }}
                            value={this.state.filter}
                        ></InputIcon>
                    </Col>
                    <div size={12} className={`${style.checkboxes}`}>
                        <Col size={3}>
                            <Checkbox checked={this.state.events} handleChange={
                                (e) => {
                                    this.setState({
                                        events: !this.state.events
                                    })
                                }
                            } inline="true" label={T.txt('events')} name='events' />
                        </Col>
                        <Col size={3}>
                            <Checkbox checked={this.state.athletes} handleChange={
                                (e) => {
                                    this.setState({
                                        athletes: !this.state.athletes
                                    })
                                }
                            } inline="true" label={T.txt('athletes')} name='athletes' />
                        </Col>
                        <Col size={3}>
                            <Checkbox checked={this.state.experiences} handleChange={
                                (e) => {
                                    this.setState({
                                        experiences: !this.state.experiences
                                    })
                                }
                            } inline="true" label={T.txt('experiences')} name='experiences' />
                        </Col>
                    </div>
                </Row>
            </form>
        )
    }
}

export default SearchFilter


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/molecules/SearchFilter/index.js